module.exports = __webpack_public_path__ + "img/bg-intro-left.jpg?5bc4efa3bc4e7b3e011977b23baac6c1";